<template>
  <v-row
    no-gutters
    class="days-item"
  >
    <v-col cols="12" sm="6" md="4">
      <router-link
        class="d-block link"
        :to="{name: 'car', params: {carid: car.id}}"
        v-ripple
      >
        <days-profile :car="car"/>
      </router-link>
    </v-col>
    <v-col cols="12" sm="6" md="8">
      <div class="timeline-outer" :class="{'timeline-mobile': breakpoint == BREAKPOINT_XS}">
        <v-btn
          text icon
          @click="$emit('moveday', -1)"
        >
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <days-timeline
          :period="period"
          :dates="dates"
          :car="car"
          :allows="allows"
          @selected="$emit('selected', $event)"
        />

        <v-btn
          text icon
          @click="$emit('moveday', 1)"
        >
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<style lang="scss">
.days-item {
  padding: {
    top: 8px;
    bottom: 7px;
    left: 0;
    right: 0;
  }
  background-color: white;
  border-bottom: solid 1px rgba(black, 0.16);

  .timeline-outer {
    display: flex;
    align-items: center;
    height: 100%;

    .v-btn {
      margin-top: 21px;
    }
  }

  .timeline-outer.timeline-mobile {
    margin: {
      left: -12px;
      right: -12px;
    }
  }

  .link {
    color: inherit;
    text-decoration: inherit;
  }
}
</style>

<script>
import PartBase from '@/mixins/PartBase'
import DaysProfile from './DaysProfile'
import DaysTimeline from './DaysTimeline'

export default {
  name: 'DaysItem',
  mixins: [
    PartBase
  ],
  components: {
    DaysProfile,
    DaysTimeline
  },
  props: {
    period: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      required: true
    },
    car: {
      type: Object,
      required: true
    },
    allows: {
      type: Array,
      required: true
    }
  }
}
</script>
